import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'site-modules/shared/hooks/use-debounce';

export function useScrollArrows(containerRef, { threshold = 0, scrollDistance, isEnabled = true } = {}) {
  const [arrows, setArrows] = useState({ left: false, right: false });

  const handleScrollBy = useCallback(direction => {
    // scroll snap doesn't work properly on iOS
    // eslint-disable-next-line venom/no-prohibited-functions
    const isIOS = window?.EDM?.preloadedState?.devicePlatform?.mapProvider === 'apple';
    const distance = isIOS ? containerRef.current.firstElementChild.clientWidth : scrollDistance || window.innerWidth;
    containerRef.current.scrollBy({ left: direction * distance, behavior: 'smooth' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function scrollLeft() {
    handleScrollBy(-1);
  }

  function scrollRight() {
    handleScrollBy(1);
  }

  const checkArrows = useDebounce(() => {
    const carousel = containerRef?.current;

    setArrows({
      left: carousel?.scrollLeft > threshold,
      right: carousel?.scrollWidth - carousel?.clientWidth - carousel?.scrollLeft > threshold + 1,
    });
  }, 50);

  useEffect(() => {
    const container = containerRef?.current;
    if (isEnabled) {
      container?.addEventListener('scroll', checkArrows);

      checkArrows();
    }

    return () => container?.removeEventListener('scroll', checkArrows);
  }, [checkArrows, isEnabled]);

  return [arrows, scrollLeft, scrollRight, checkArrows];
}
